import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { FaEnvelope, FaLock, FaArrowLeft } from 'react-icons/fa';
import { motion } from 'framer-motion';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email: email,
        password: password,
      });

      if (signInError) {
        throw signInError;
      }

      // No need to set localStorage, Supabase client handles the session
      navigate('/admin/dashboard');

    } catch (error) {
      setError(error.message || 'Credenciales inválidas. Por favor, inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center p-4 font-sans">
      <div 
        className="absolute inset-0 bg-cover bg-center" 
        style={{ backgroundImage: `url('/images/casa.webp')` }}
      />
      <div className="absolute inset-0 bg-black/70" />

      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="relative bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl w-full max-w-sm p-8 sm:p-10"
      >
        <div className="text-center mb-10">
          <h1 className="text-4xl font-playfair font-bold text-gray-900 mb-2">
            Bienvenido Administrador
          </h1>
          <p className="text-gray-500">Panel de Administración de Sumaq Mayu</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          {error && (
            <motion.div 
              initial={{ opacity: 0 }} 
              animate={{ opacity: 1 }} 
              className="bg-red-100 border-l-4 border-red-500 text-red-800 px-4 py-3 rounded-lg text-sm"
            >
              {error}
            </motion.div>
          )}

          <div className="relative">
            <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-600">
              Email
            </label>
            <FaEnvelope className="absolute left-4 top-11 text-gray-400" />
            <input
              type="text"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
              required
              className="w-full pl-12 pr-4 p-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-400 focus:border-green-400 transition"
            />
          </div>

          <div className="relative">
            <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-600">
              Contraseña
            </label>
            <FaLock className="absolute left-4 top-11 text-gray-400" />
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              className="w-full pl-12 pr-4 p-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-400 focus:border-green-400 transition"
            />
          </div>

          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            type="submit"
            disabled={loading}
            className="w-full bg-jungle-800 text-white p-3 rounded-lg font-semibold text-base uppercase tracking-wider hover:bg-jungle-900 shadow-lg hover:shadow-xl transition-all duration-300 disabled:bg-gray-400"
          >
            {loading ? 'Verificando...' : 'Iniciar Sesión'}
          </motion.button>
        </form>

        <div className="mt-8 text-center">
          <button
            onClick={() => navigate('/')}
            className="text-sm text-gray-500 hover:text-green-600 transition inline-flex items-center gap-2"
          >
            <FaArrowLeft /> Volver al inicio
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;